<template>
    <transition name="fade">

        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content shadow-lg" style="background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <slot />
                        <p class="h4 fw-bold" style="color: var(--theme-text-main); font-size: 1.5em; text-align: center; margin-bottom: 20px;">{{enter_barcode_or_name}}</p>
                        
                        <div class="form-group">
                            <input v-model="checkbarcode" id="checkbarcode" v-on:keyup.enter="getProduct(checkbarcode)" placeholder="Enter product barcode to edit" class="form-control input-lg" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;"/>
                        </div>

                        <div style="width:100%; margin-top: 20px;">
                            <ul style="list-style: none; padding: 0;">
                            <found-prod
                                v-for="(product, index) in filterdProducts"
                                :key="product. item_code"
                                :item_name="product. item_name"
                                :item_code="product. item_code"
                                :barcode="product. barcode"
                                :standard_rate="product. standard_rate"
                                :arrayCounter="product.arrayCounter"
                                :updatedPointer="product.updatedPointer"
                                :new_standard_rate="product.new_standard_rate"
                                :index="index"
                                @remove="filterdProducts.splice(index, 1)"
                                @handleRevertProductPrice="revertProductChange(index, $event)"
                                @setProductNewPrice="updateFoundProductPrice(index, $event)"
                            ></found-prod>
                            </ul> 
                        </div>

                        <div style="display:flex; justify-content:space-between; ;text-align: center; margin-top: 20px;">
                            <button @click="getProduct(checkbarcode)" class="btn btn-success btn-lg" style="font-size: 1.2em; padding: 10px 30px;">Get Price</button>
                            <button @click="handleClose()" class="btn btn-danger btn-lg" style="font-size: 1.2em; padding: 10px 30px;">Close</button>

                        </div>
                    </div>
                </div>

            </transition>

                                    <div class="col-sm-4" style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;color: var(--theme-text-main);margin-left: -15px;margin-right: -10px;">
                        <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="showKeypad"/>
                        </div>
        </div>
    </transition>
</template>
<script>
import numericpad from "@/components/SimpleKeyboard";
import axios from "axios";
import FoundProd from '@/components/FoundProd'
import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],
    mounted() {
        this.$el.querySelector('#checkbarcode').focus = true;

        if(this.msgItems.length>0){
            this.enter_barcode_or_name = this.msgItems[0].cont;
        }  
    },
    name:"CheckPrice",
    components:{ FoundProd, numericpad },
    data: function(){        
        return {
            showKeypad: true,
            enter_barcode_or_name:'',
            checkbarcode: '',
            price: 0,
            checkPriceErrorMsg: '',
            item_name: '',
            filterdProducts: [],
            
        }
    },
    methods:{
    onInput(key) {
      console.log("key", key);
      if(key == 11){
        this.checkbarcode = (this.checkbarcode + "0").slice(0, this.maxLength);
        }else{
          this.checkbarcode = (this.checkbarcode + key).slice(0, this.maxLength);
        }
        this.getProduct(this.checkbarcode);
    },
    onDelete() {
      this.checkbarcode = this.checkbarcode.slice(0, this.checkbarcode.length - 1);
      this.getProduct(this.checkbarcode);
    },
    onReset() {
      this.checkbarcode = "";
      //document.getElementById("checkprice_barcode").style.borderWidth ='1px'; 
      //document.getElementById("checkprice_barcode").style.borderColor ='black'; 
    },        
        handleClose(){
            this.price= 0;
            this.item_name= '';
            this.close();
        },

    getProduct: async function(barcodeVar){
        document.getElementById("checkbarcode").style.borderWidth ='1px'; 
        document.getElementById("checkbarcode").style.borderColor ='black'; 
        this.price = 0;
        if(barcodeVar !== '' && barcodeVar.length > 3){
          try{
              let dataURL = this.apiURL+'Products/findProductLocal?appId=7&product='+barcodeVar;
              //let dataURL = this.apiURL+'GiftCard/findProductByCondLocal?appId=7&product='+barcodeVar;
              
              let response = await axios.post(dataURL, {"appId": localStorage.appId, "barcode": barcodeVar}); 
              this.filterdProducts = [];
              if(response.data.results.products.length < 100){          
                this.filterdProducts= response.data.results.products;
              }else{
                let newBacode = '';
                let item_price = '';
                let item_qty = '';
                let newBacodeType = '';              
                newBacodeType = barcodeVar.substring(0,2);
                newBacode = barcodeVar.substring(2,7);
                if(newBacodeType === '99'){
                  item_price = barcodeVar.substring(15,barcodeVar.length);
                this.getNewProduct(newBacode, item_qty, item_price);
                }else if(newBacodeType === '97'){
                  item_qty = barcodeVar.substring(15,barcodeVar.length);
                this.getNewProduct(newBacode, item_qty, item_price);
                }else{
                    document.getElementById("checkbarcode").style.borderWidth ='3px'; 
                    document.getElementById("checkbarcode").style.borderColor ='red'; 
                }
              }
          }
          catch (error){
              console.log(error);
          }


        }
    },      
      getNewProduct: async function(newBarcode, item_qty, item_price){
        try{
            let dataURL = this.apiURL+'Products/findProductLocal?appId=7&barcode='+newBarcode;
            let response = await axios.post(dataURL, {"appId": localStorage.appId, "barcode": newBarcode}); 
            this.filterdProducts= response.data.results.products;

            if(this.filterdProducts.length===1){
              let price = 0;
              let standard_rate = parseFloat(this.filterdProducts[0].standard_rate).toFixed(2);
              let qty = 0;            
              if(item_price !== ''){
                price = parseFloat((item_price/1000)).toFixed(2);
                if(standard_rate>0){
                  qty = (item_price*1000)/(standard_rate*1000)
                }
              }else if(item_qty !== ''){
                qty = parseFloat((item_qty/10000)).toFixed(3);
                price = parseFloat(qty*standard_rate).toFixed(2);

              }
            }
        }
        catch (error){
            console.log(error);
        }
      },      

    getProductByName: async function(barcodeVar){
        if(barcodeVar !== ''){
          try{
              let dataURL = this.apiURL+'Products/findProductByName';
              let response = await axios.post(dataURL, {"appId": localStorage.appId, "item_name": barcodeVar}); 
              this.filterdProducts= response.data.results.products;
              if(this.filterdProducts.length === 1){          
                this.price = this.filterdProducts[0].standard_rate;
                this.item_name = this.filterdProducts[0].item_name;
                this.checkbarcode = '';
              }else{
                if(this.filterdProducts.length > 1){
                    this.checkPriceErrorMsg = "There is no result or there are many results";
                }
                if(this.filterdProducts.length === 0){
                    this.getProductByCode(barcodeVar);
                }
              }
          }
          catch (error){
              console.log(error);
          }


        }
    },     
    getProductByCode: async function(barcodeVar){
        if(barcodeVar !== ''){
          try{
              let dataURL = this.apiURL+'Products/findProductByCode?appId=7&item_code='+barcodeVar;
              let response = await axios.post(dataURL, {"appId": localStorage.appId, "item_code": barcodeVar}); 
              this.filterdProducts= response.data.results.products;
              if(this.filterdProducts.length === 1){          
                this.price = this.filterdProducts[0].standard_rate;
                this.item_name = this.filterdProducts[0].item_name;
                this.checkbarcode = '';
              }else{
                document.getElementById("checkprice_barcode").style.borderWidth ='3px'; 
                document.getElementById("checkprice_barcode").style.borderColor ='red'; 
                console.log("dddd", document.getElementById("checkprice_barcode"));                
              }
          }
          catch (error){
              console.log(error);
          }


        }
    },     

      getNewProduct: async function(newBarcode, item_qty, item_price){
        try{
            let dataURL = this.apiURL+'Products/findProductLocal?appId=7&barcode='+newBarcode;
            let response = await axios.post(dataURL, {"appId": localStorage.appId, "barcode": newBarcode}); 
            this.filterdProducts= response.data.results.products;
            if(this.filterdProducts.length===1){
              let price = 0;
              let standard_rate = parseFloat(this.filterdProducts[0].standard_rate).toFixed(2);
              let qty = 0;            
              if(item_price !== ''){
                price = parseFloat((item_price/1000)).toFixed(2);
                if(standard_rate>0){
                  qty = (item_price*1000)/(standard_rate*1000)
                }
              }else if(item_qty !== ''){
                qty = parseFloat((item_qty/10000)).toFixed(3);
                price = parseFloat(qty*standard_rate).toFixed(2);

              }
                this.price = this.filterdProducts[0].standard_rate;
                this.item_name = this.filterdProducts[0].item_name;
                this.checkbarcode = '';
            }else{
                console.log("getProductByName", this.checkbarcode);
                if(this.filterdProducts.length===0){
                    this.getProductByName(this.checkbarcode)
                }
            }
        }
        catch (error){
            console.log(error);
        }
      },      

/*
        findProduct: function (checkbarcodeP) {
          
          let h = parseInt(checkbarcodeP)
          console.log("h",h);
          let foundProd = this.products[h];
          console.log("products.length",this.products.length);
          console.log("products.length",this.products);
          this.filterdProducts.push(foundProd)
        },
        */
        findNewProduct: function (newBarcode, item_price) {
            this.filterdProducts=this.products.filter(function(a){
                if(a.barcode != null){
                    if(a.barcode.toLowerCase()===newBarcode.toLowerCase())
                    {
                       return true;
                    }
                }
                   return false;
                }                
            );
            if(this.filterdProducts.length===1){
                this.price = parseFloat(this.filterdProducts[0].standard_rate).toFixed(2);//parseFloat(item_price)/100;
                this.item_name = this.filterdProducts[0].item_name;
                this.checkbarcode = '';
            }else{
                document.getElementById("checkbarcode").style.borderWidth ='3px'; 
                document.getElementById("checkbarcode").style.borderColor ='red'; 
            }

        },        
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
        products: {
            type:Array,
            required:true
        },
        msgItems: {
            type:Array,
            required:true
        },  
    },
    setup(_, { emit }){    
        const close = () => {              
            emit('close');
        };
        const display = () => {              
        if(this.msgItems.length>0){
            this.enter_barcode_or_name = this.msgItems[0].cont;

        } 

        };
        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.vue-modal-inner {
  max-width: 90%;
  max-height: 90vh;
  margin: 0;
}
.vue-modal-content {

  position: relative;
  /*background: url(../assets/bg.png) no-repeat center center fixed;*/
  background-color: #656565;
  background-size: cover;         
  background-clip: padding-box;
  border-radius: 1rem;
  padding: 1rem;
  width: 700px;
  height: auto;
  max-height: 90vh;
  overflow: auto;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
/*
@import "https://unpkg.com/primitive-ui/dist/css/main.css"
*/
.fig-form-control{
box-sizing: border-box;

position: absolute;
width: 440px;
height: 44px;
left: 30px;
top: 79px;

background: rgba(255, 255, 255, 0.8);
border: 1px solid #1a1f2f;
border-radius: 5px;   
 
}
.fig-label{
position: absolute;
width: 115px;
height: 19px;
left: 30px;
top: 157px;

font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 19px;

color: #FFFFFF;
 
}

</style>
